import React, { Fragment } from "react";
import { AuditCategory } from "features/../../../shared/constants/enums";
import { ListBuilder, Table, Format } from "@redriver/cinnamon";
import { TablePagination } from "components/pagination";
import { useTranslation } from "react-i18next";
import { AuditColumns } from "constants/enums";

const ListAudits = ({
  loadAudits,
  entityId,
  columns = [
    AuditColumns.User,
    AuditColumns.DateTime,
    AuditColumns.Type,
    AuditColumns.Audit,
  ],
}) => {
  const { t } = useTranslation("auditing");

  const allColumns = {
    [AuditColumns.DateTime]: {
      title: t("Date_Time"),
      render: (audit) => <Format.DateTime value={audit.createdUtc} />,
    },
    [AuditColumns.User]: {
      title: t("User"),
      render: (audit) => audit.createdBy?.text ?? "System",
    },
    [AuditColumns.Category]: {
      title: t("Category"),
      render: (audit) => audit.category.text,
    },
    [AuditColumns.Type]: {
      title: t("Type"),
      render: (audit) => audit.type?.text,
    },
    [AuditColumns.Audit]: {
      title: t("Audit"),
      render: (audit) => {
        const raw = audit?.value ?? "";
        // 1) remove any "[Anything] - " prefix
        const clean = raw.replace(/^\[[^\]]+\]\s*-\s*/, "");
        // 2) split on " - " when the next part looks like a new sentence/field
        //    (avoids splitting inside quotes)
        const parts = clean
          .split(/\s-\s(?=[A-Z])/)
          .flatMap((p) => p.split(/\r?\n/)) // also handle backend newlines
          .filter(Boolean);

        return (
          <span style={{ whiteSpace: "pre-wrap" }}>
            {parts.map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </span>
        );
      },
    },
  };

  const visibleColumns = columns?.length
    ? columns.map((key) => allColumns[key])
    : Object.values(allColumns);

  return (
    <ListBuilder
      withTable
      loadAction={loadAudits}
      loadParams={{ sheetId: entityId }}
      dataTransform={(data) => data.results}
      totalTransform={(data) => data.totalResults}
      initialPagination={{ pageSize: 25, pageNumber: 1 }}
      initialFilters={{
        auditCategory: [{ value: AuditCategory.Audit }],
        category: [AuditCategory.Audit],
      }}
      renderList={(tableProps, state, events) => (
        <Fragment>
          <Table {...tableProps} dataKey="id" emptyMessage="No audits found">
            {visibleColumns.map((col, i) => (
              <Table.Column
                key={i}
                title={col.title}
                sx={col.sx}
                width={col.width}
                render={col.render}
              />
            ))}
          </Table>
          <TablePagination
            pageNumber={state.pagination.pageNumber}
            onChange={events.onChangePagination}
            pageSize={state.pagination.pageSize}
            totalItems={state.total}
          />
        </Fragment>
      )}
    />
  );
};

export default ListAudits;
